<template>
  <div class="mt-4">
    <el-row :gutter="16">
      <el-col :span="12" :offset="0">
        <div class="bg-white rounded-6px pt-24px pb-12px px-24px">
          <el-row :gutter="50">
            <el-col
              :span="6"
              :offset="0"
              v-for="(item, index) in innerActiviteCates"
              :key="index"
              class="group cursor-pointer"
              @click.native="toCateList(item)"
            >
              <div class="!flex justify-center">
                <el-image :src="item.img" class="w-60px h-60px" fit="fill" :lazy="true"></el-image>
              </div>
              <p class="text-14px text-center truncate line-clamp-1 leading-22px mt-8px group-hover:text-[#06C167]">
                {{ item.cateName }}
              </p>
            </el-col>
          </el-row>
        </div>
      </el-col>
      <el-col :span="12" :offset="0">
        <div class="bg-white rounded-6px pt-24px pb-12px px-24px">
          <el-row :gutter="50">
            <el-col
              :span="6"
              :offset="0"
              v-for="(item, index) in outerActiviteCates"
              :key="index"
              class="group cursor-pointer"
              @click.native="toActivityProducts(item)"
            >
              <div class="!flex justify-center">
                <el-image :src="item.img" class="w-60px h-60px" fit="fill" :lazy="true"></el-image>
              </div>
              <p class="text-14px text-center truncate line-clamp-1 leading-22px mt-8px group-hover:text-[#06C167]">
                {{ item.cateName }}
              </p>
            </el-col>
          </el-row>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script setup lang="ts">
import { appInfo } from '@/stores/appInfo';
const innerActiviteCates = computed(() => {
  return appInfo().appSetting?.activiteCates?.filter(item => item.cateSource == 'inner') ?? [];
});

const outerActiviteCates = computed(() => {
  return appInfo().appSetting?.activiteCates?.filter(item => item.cateSource == 'outer') ?? [];
});

function toCateList(cate) {
  useRouter().push({
    path: '/product/list',
    query: {
      shopName: '数智化商城',
      productCategoryId: cate.cateId,
      categoryLevel: 1,
    },
  });
}

function toActivityProducts(cate) {
  useRouter().push({
    path: '/product/activityProducts',
    query: {
      // productIds: cate.productIds,
      cateName: cate.cateName,
    },
  });
}
</script>

<style scoped></style>
